import TreeDataController from '../../../../common/generic/tree/TreeDataController';
import { TDataNode, TId } from '../../../../common/generic/tree/types';

export default class TreeNode<
  TNodeProps extends Record<string, unknown> = Record<string, unknown>,
> {
  constructor(
    public id: TId,
    public handler: TreeDataController<TNodeProps>,
  ) {}

  getChildren() {
    const { props } = this;

    return props.children.map((current) => new TreeNode(current, this.handler));
  }

  get props() {
    return this.handler.propsStore.getFieldProps(this.id);
  }

  update(
    props: Partial<
      Omit<
        TDataNode,
        | 'actualParentId'
        | 'children'
        | 'hasLoaded'
        | 'id'
        | 'labelRenderer'
        | 'parentId'
      >
    >,
  ) {
    this.handler.propsStore.updateField(this.id, props);
  }
}
